import React from 'react';
import {PropostaItemAPI} from '../../../../services/creditoMova';
import {PropostaDTO} from '../../../../dtos/EmprestimoDTO';
import {formatDateBR, formatCentavos} from '../../../../utils/format';

import {
  PropostaCard,
  PropostaCardHeader,
  PropostaCardDate,
  PropostaStatusPill,
  PropostaStatusText,
  PropostaCardBody,
  PropostaCardRow,
  PropostaCardLabel,
  PropostaCardValue,
  PropostaCardDivider,
  PropostaCardAction,
  PropostaCardActionText,
  PropostaCardActionIcon,
} from './styles';

type Props = {
  item: PropostaItemAPI;
  onPress: () => void;
};

function getStatusText(nextAction: string): string {
  switch (nextAction) {
    case 'aguardar_webhook':
    case 'aguardando_analise':
    case 'em_analise':
      return 'Em Análise';
    case 'acompanhar':
      return 'Aprovada';
    case 'assinar':
      return 'Em assinatura';
    case 'reprovada':
      return 'Reprovada';
    case 'cancelada':
      return 'Cancelada';
    default:
      return nextAction;
  }
}

function getStatus(nextAction: string): PropostaDTO['status'] {
  switch (nextAction) {
    case 'aguardar_webhook':
    case 'continuar':
    case 'aguardando_analise':
    case 'em_analise':
      return 'analise';
    case 'acompanhar':
      return 'aprovada';
    case 'assinar':
      return 'assinatura';
    case 'reprovada':
      return 'reprovada';
    case 'cancelada':
      return 'cancelada';
    default:
      return 'analise';
  }
}

export function PropostaItemCard({item, onPress}: Props) {
  const statusQuery =
    item.status === 'em_analise' ? item.status : item.next_action;
  const status = getStatus(statusQuery);
  const statusText = getStatusText(statusQuery);

  return (
    <PropostaCard activeOpacity={1} onPress={onPress}>
      <PropostaCardHeader>
        <PropostaCardDate>Enviada em {formatDateBR(item.created_at)}</PropostaCardDate>
        <PropostaStatusPill status={status}>
          <PropostaStatusText>{statusText}</PropostaStatusText>
        </PropostaStatusPill>
      </PropostaCardHeader>

      <PropostaCardBody>
        <PropostaCardRow>
          <PropostaCardLabel>Valor solicitado</PropostaCardLabel>
          <PropostaCardValue>
            {formatCentavos(item.valor_solicitado_centavos)}
          </PropostaCardValue>
        </PropostaCardRow>

        {item.valor_aprovado_centavos > 0 && (
          <PropostaCardRow>
            <PropostaCardLabel>Valor aprovado</PropostaCardLabel>
            <PropostaCardValue>
              {formatCentavos(item.valor_aprovado_centavos)}
            </PropostaCardValue>
          </PropostaCardRow>
        )}

        {item.valor_contratado_centavos > 0 && item.valor_aprovado_centavos > 0 && (
          <PropostaCardRow>
            <PropostaCardLabel>Impostos e custos</PropostaCardLabel>
            <PropostaCardValue>
              {formatCentavos(
                item.valor_contratado_centavos - item.valor_aprovado_centavos,
              )}
            </PropostaCardValue>
          </PropostaCardRow>
        )}

        <PropostaCardDivider />
        <PropostaCardRow>
          <PropostaCardLabel>Total</PropostaCardLabel>
          <PropostaCardValue>
            {formatCentavos(item.valor_contratado_centavos)}
          </PropostaCardValue>
        </PropostaCardRow>
      </PropostaCardBody>

      {item.next_action === 'assinar' && (
        <PropostaCardAction>
          <PropostaCardActionText>Assinar contrato</PropostaCardActionText>
          <PropostaCardActionIcon name="arrow-right" />
        </PropostaCardAction>
      )}
    </PropostaCard>
  );
}
